import { getCookie } from '@lemonade-hq/cdk';
import type { Language, Region } from '@lemonade-hq/lemonation';
import {
  DE_DE_LOCALE,
  EN_FR_LOCALE,
  EN_LANGUAGE,
  EN_NL_LOCALE,
  EN_US_LOCALE,
  FR_FR_LOCALE,
  NL_NL_LOCALE,
  US_REGION,
} from '@lemonade-hq/lemonation';
import type {
  AnalyticsConfig,
  AuthConfig,
  InfraConfig,
  LocaleConfig,
  NavConfig,
  RealtimeConfig,
  SecurityConfig,
} from '@lemonade-hq/nuiza';
import { Env } from '@lemonade-hq/nuiza';
import type { FlagsConfig } from '@lemonade-hq/uniclient-app';
import { buildEdgeServiceUrl, EdgeService } from '@lemonade-hq/uniclient-chat';
import deDeTranslation from './translations/de-DE.json';
import enFrTranslation from './translations/en-FR.json';
import enNlTranslation from './translations/en-NL.json';
import enUsTranslation from './translations/en-US.json';
import frFrTranslation from './translations/fr-FR.json';
import nlNlTranslation from './translations/nl-NL.json';

// CONFIG *******************

export function googleMapConfig(): string {
  return process.env.GOOGLE_MAP_API_KEY ?? '';
}

export function realtimeConfig(): RealtimeConfig {
  return {
    pubnubSubscribeKey: process.env.REALTIME_PUBNUB_SUBSCRIBE_KEY ?? '',
  };
}

export function analyticsConfig(): AnalyticsConfig {
  return {};
}

export function infraConfig(): InfraConfig {
  return {
    env: (window.lemonade?.stage ?? Env.Development) as Env,
    envId: window.lemonade?.envId ?? 'master',
    service: 'chat',
  };
}

export function flagsConfig(): FlagsConfig {
  return {
    url: process.env.UNLEASH_URL ?? '',
    clientKey: process.env.UNLEASH_CLIENT_KEY ?? '',
    environment: process.env.UNLEASH_ENV ?? 'development',
  };
}

export function localeConfig(): LocaleConfig {
  const lang = (getCookie('language')?.toLowerCase() ?? EN_LANGUAGE) as Language;
  const region = (getCookie('region')?.toUpperCase() ?? US_REGION) as Region;

  return {
    includeCommonI18nContext: false,
    lang,
    region,
    translations: {
      [EN_US_LOCALE]: { ...enUsTranslation },
      [FR_FR_LOCALE]: { ...frFrTranslation },
      [EN_FR_LOCALE]: { ...enFrTranslation },
      [DE_DE_LOCALE]: { ...deDeTranslation },
      [EN_NL_LOCALE]: { ...enNlTranslation },
      [NL_NL_LOCALE]: { ...nlNlTranslation },
    },
  };
}

export function navConfig({ env, envId }: InfraConfig): NavConfig {
  return {
    monolithUrl: window.lemonade?.monolithUrl ?? buildEdgeServiceUrl(EdgeService.Monolith, env, envId),
    consumerUrl: window.lemonade?.consumerUrl ?? buildEdgeServiceUrl(EdgeService.Consumer, env, envId),
    marketingUrl: window.lemonade?.monolithUrl ?? buildEdgeServiceUrl(EdgeService.Monolith, env, envId),
  };
}

export function securityConfig(): SecurityConfig {
  return {
    csrf: '',
  };
}

export function authConfig(baseUrl: string): AuthConfig {
  return {
    loginUrl: `${baseUrl}/auth/login`,
    logoutUrl: `${baseUrl}/auth/force_logout`, // TODO: change this to /logout once auth logout supports redirect url
    userInfoUrl: `${baseUrl}/auth/me`,
    unauthorizedBehavior: 'callback',
  };
}
